/** Extrait le numéro d’un matricule `M0001`, `M001`, etc. */
export function parseMatriculeNumero(matricule: string): number | null {
  const match = matricule.trim().match(/^M(\d+)$/i);
  if (!match?.[1]) return null;
  const num = Number(match[1]);
  return Number.isInteger(num) && num > 0 ? num : null;
}

/** Format attendu en création : M + 4 chiffres (M0001). */
export function formatMatricule(num: number): string {
  return `M${String(num).padStart(4, '0')}`;
}

/** Prochain matricule libre pour le tenant courant. */
export function prochainMatricule(salaries: ReadonlyArray<{ matricule: string }>): string {
  const numeros = salaries
    .map((s) => parseMatriculeNumero(s.matricule))
    .filter((n): n is number => n !== null);
  let next = numeros.length > 0 ? Math.max(...numeros) + 1 : 1;
  const pris = new Set(salaries.map((s) => s.matricule.trim().toLowerCase()));
  while (pris.has(formatMatricule(next).toLowerCase())) {
    next += 1;
  }
  return formatMatricule(next);
}

/** Attribue M0001, M0002… aux lignes sans matricule (import CSV). */
export function assignMatriculesSequentiels<T extends { matricule: string }>(
  drafts: readonly T[],
  existing: ReadonlyArray<{ matricule: string }>,
): T[] {
  const pool = [...existing];
  return drafts.map((draft) => {
    const trimmed = draft.matricule.trim();
    const matricule = trimmed ? trimmed : prochainMatricule(pool);
    pool.push({ matricule });
    return { ...draft, matricule };
  });
}
